import { createI18n } from '@multaqa/i18n'
import arAlerts from '@multaqa/i18n/locales/ar/alerts.json'
import arCollections from '@multaqa/i18n/locales/ar/collections.json'
import arCompanyAuth from '@multaqa/i18n/locales/ar/company-auth.json'
import arConditionFilter from '@multaqa/i18n/locales/ar/condition-filter.json'
import arCoreAttachments from '@multaqa/i18n/locales/ar/core-attachments.json'
import arFaceEncoder from '@multaqa/i18n/locales/ar/face-encoder.json'
import arGroupReports from '@multaqa/i18n/locales/ar/group-reports.json'
import arHr from '@multaqa/i18n/locales/ar/hr.json'
import arHrAssets from '@multaqa/i18n/locales/ar/hr-assets.json'
import arHrAttendance from '@multaqa/i18n/locales/ar/hr-attendance.json'
import arHrCashCustody from '@multaqa/i18n/locales/ar/hr-cash-custody.json'
import arHrConduct from '@multaqa/i18n/locales/ar/hr-conduct.json'
import arHrEmployees from '@multaqa/i18n/locales/ar/hr-employees.json'
import arHrExpenses from '@multaqa/i18n/locales/ar/hr-expenses.json'
import arHrHome from '@multaqa/i18n/locales/ar/hr-home.json'
import arHrLeave from '@multaqa/i18n/locales/ar/hr-leave.json'
import arHrOrg from '@multaqa/i18n/locales/ar/hr-org.json'
import arHrPerformance from '@multaqa/i18n/locales/ar/hr-performance.json'
import arHrReports from '@multaqa/i18n/locales/ar/hr-reports.json'
import arHrSettings from '@multaqa/i18n/locales/ar/hr-settings.json'
import arInventory from '@multaqa/i18n/locales/ar/inventory.json'
import arNotifications from '@multaqa/i18n/locales/ar/notifications.json'
import arOnlineApplication from '@multaqa/i18n/locales/ar/online-application.json'
import arPayroll from '@multaqa/i18n/locales/ar/payroll.json'
import arPayrollRun from '@multaqa/i18n/locales/ar/payroll-run.json'
import arProducts from '@multaqa/i18n/locales/ar/products.json'
import arPurchasing from '@multaqa/i18n/locales/ar/purchasing.json'
import arRecruitmentBoard from '@multaqa/i18n/locales/ar/recruitment-board.json'
import arRecruitmentDashboard from '@multaqa/i18n/locales/ar/recruitment-dashboard.json'
import arRoleEditor from '@multaqa/i18n/locales/ar/role-editor.json'
import arSales from '@multaqa/i18n/locales/ar/sales.json'
import arSelfService from '@multaqa/i18n/locales/ar/self-service.json'
import arUsers from '@multaqa/i18n/locales/ar/users.json'
import arWorkflow from '@multaqa/i18n/locales/ar/workflow.json'
import enAlerts from '@multaqa/i18n/locales/en/alerts.json'
import enCollections from '@multaqa/i18n/locales/en/collections.json'
import enCompanyAuth from '@multaqa/i18n/locales/en/company-auth.json'
import enConditionFilter from '@multaqa/i18n/locales/en/condition-filter.json'
import enCoreAttachments from '@multaqa/i18n/locales/en/core-attachments.json'
import enFaceEncoder from '@multaqa/i18n/locales/en/face-encoder.json'
import enGroupReports from '@multaqa/i18n/locales/en/group-reports.json'
import enHr from '@multaqa/i18n/locales/en/hr.json'
import enHrAssets from '@multaqa/i18n/locales/en/hr-assets.json'
import enHrAttendance from '@multaqa/i18n/locales/en/hr-attendance.json'
import enHrCashCustody from '@multaqa/i18n/locales/en/hr-cash-custody.json'
import enHrConduct from '@multaqa/i18n/locales/en/hr-conduct.json'
import enHrEmployees from '@multaqa/i18n/locales/en/hr-employees.json'
import enHrExpenses from '@multaqa/i18n/locales/en/hr-expenses.json'
import enHrHome from '@multaqa/i18n/locales/en/hr-home.json'
import enHrLeave from '@multaqa/i18n/locales/en/hr-leave.json'
import enHrOrg from '@multaqa/i18n/locales/en/hr-org.json'
import enHrPerformance from '@multaqa/i18n/locales/en/hr-performance.json'
import enHrReports from '@multaqa/i18n/locales/en/hr-reports.json'
import enHrSettings from '@multaqa/i18n/locales/en/hr-settings.json'
import enInventory from '@multaqa/i18n/locales/en/inventory.json'
import enNotifications from '@multaqa/i18n/locales/en/notifications.json'
import enOnlineApplication from '@multaqa/i18n/locales/en/online-application.json'
import enPayroll from '@multaqa/i18n/locales/en/payroll.json'
import enPayrollRun from '@multaqa/i18n/locales/en/payroll-run.json'
import enProducts from '@multaqa/i18n/locales/en/products.json'
import enPurchasing from '@multaqa/i18n/locales/en/purchasing.json'
import enRecruitmentBoard from '@multaqa/i18n/locales/en/recruitment-board.json'
import enRecruitmentDashboard from '@multaqa/i18n/locales/en/recruitment-dashboard.json'
import enRoleEditor from '@multaqa/i18n/locales/en/role-editor.json'
import enSales from '@multaqa/i18n/locales/en/sales.json'
import enSelfService from '@multaqa/i18n/locales/en/self-service.json'
import enUsers from '@multaqa/i18n/locales/en/users.json'
import enWorkflow from '@multaqa/i18n/locales/en/workflow.json'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RoutePending } from '@/components/route-pending'
import { handoffAfterFirstRoute } from '@/lib/boot-splash'
import { createQueryClient } from '@/lib/query-client'
import { initSentry } from '@/lib/sentry'
import { applyTheme, useUiStore } from '@/stores/ui'
import { routeTree } from './routeTree.gen'
import './styles.css'

initSentry()

/*
 * One namespace per HR slice, plus Core's attachments — all eight registered
 * here, once, by plans/09-hr-00-foundation. Seven agents build the screens in
 * parallel and each fills its OWN file; none of them opens this one
 * (design §8).
 *
 * `core-attachments` is Core's, not HR's: slice 1's attachment strings belong
 * to the module that owns them and Accounting and Recruitment will reuse them.
 * It is registered here for the same reason as the other seven.
 *
 * Accounting namespaces are loaded by the accounting route boundary. The
 * loader imports both locales so switching language remains immediate after
 * entering the module, while keeping feature translations out of bootstrap.
 */
const RESOURCES = {
  en: {
    'condition-filter': enConditionFilter,
    // `hr-home` is slice 8's, not one of the seven: the HR landing page is a
    // cross-cutting screen no single slice owned (design 1a).
    'hr-home': enHrHome,
    'hr-employees': enHrEmployees,
    'hr-org': enHrOrg,
    'hr-attendance': enHrAttendance,
    'hr-cash-custody': enHrCashCustody,
    'hr-conduct': enHrConduct,
    'hr-leave': enHrLeave,
    hr: enHr,
    'hr-expenses': enHrExpenses,
    'hr-performance': enHrPerformance,
    'hr-reports': enHrReports,
    'hr-settings': enHrSettings,
    inventory: enInventory,
    'hr-assets': enHrAssets,
    'core-attachments': enCoreAttachments,
    'company-auth': enCompanyAuth,
    'face-encoder': enFaceEncoder,
    'group-reports': enGroupReports,
    products: enProducts,
    purchasing: enPurchasing,
    sales: enSales,
    collections: enCollections,
    payroll: enPayroll,
    'payroll-run': enPayrollRun,
    'recruitment-board': enRecruitmentBoard,
    'recruitment-dashboard': enRecruitmentDashboard,
    'role-editor': enRoleEditor,
    workflow: enWorkflow,
    notifications: enNotifications,
    alerts: enAlerts,
    'self-service': enSelfService,
    users: enUsers,
    'online-application': enOnlineApplication,
  },
  ar: {
    'condition-filter': arConditionFilter,
    'hr-home': arHrHome,
    'hr-employees': arHrEmployees,
    'hr-org': arHrOrg,
    'hr-attendance': arHrAttendance,
    'hr-cash-custody': arHrCashCustody,
    'hr-conduct': arHrConduct,
    'hr-leave': arHrLeave,
    hr: arHr,
    'hr-expenses': arHrExpenses,
    'hr-performance': arHrPerformance,
    'hr-reports': arHrReports,
    'hr-settings': arHrSettings,
    inventory: arInventory,
    'hr-assets': arHrAssets,
    'core-attachments': arCoreAttachments,
    'company-auth': arCompanyAuth,
    'face-encoder': arFaceEncoder,
    'group-reports': arGroupReports,
    products: arProducts,
    purchasing: arPurchasing,
    sales: arSales,
    collections: arCollections,
    payroll: arPayroll,
    'payroll-run': arPayrollRun,
    'recruitment-board': arRecruitmentBoard,
    'recruitment-dashboard': arRecruitmentDashboard,
    'role-editor': arRoleEditor,
    workflow: arWorkflow,
    notifications: arNotifications,
    alerts: arAlerts,
    'self-service': arSelfService,
    users: arUsers,
    'online-application': arOnlineApplication,
  },
}

// Before render, both of them. i18n init after the first paint shows a flash of
// raw translation keys; theme after the first paint shows a flash of white.
createI18n({ resources: RESOURCES })
applyTheme(useUiStore.getState().theme)

const queryClient = createQueryClient()

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPendingComponent: RoutePending,
  defaultPreload: 'intent',
  // The router does not cache data — TanStack Query does. Setting this to 0
  // stops the two keeping separate, divergent copies of the same response.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

handoffAfterFirstRoute(router)

declare module '@tanstack/react-router' {
  interface HistoryState {
    idleExpiryRedirect?: true
  }

  interface Register {
    router: typeof router
  }
}

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root element #root is missing from index.html')
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
